import { render, staticRenderFns } from "./addPartner.vue?vue&type=template&id=13a82c18"
import script from "./addPartner.vue?vue&type=script&lang=js"
export * from "./addPartner.vue?vue&type=script&lang=js"
import style0 from "./addPartner.vue?vue&type=style&index=0&id=13a82c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports